<form [formGroup]="form" *ngIf="form">
  <h2 class="sub-text">Account Registration</h2>
  <h4>Please provide the following information to create your account</h4>
  <div class="column-2">
    <div class="col">
      <div class="input-container">
        <label> First Name </label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="firstName" />
          <mat-error *ngIf="errorHandling('firstName', 'required')">
            First Name is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="input-container">
        <label> Last Name </label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="lastName" />
          <mat-error *ngIf="errorHandling('lastName', 'required')">
            Last Name is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="input-container">
        <label>
          Title
          <button
            mat-icon-button
            class="btn-hint"
            matTooltip="Job title within the company"
          >
            <mat-icon>help</mat-icon>
          </button></label
        >
        <mat-form-field appearance="outline">
          <input matInput formControlName="title" />
          <mat-error *ngIf="errorHandling('title', 'required')">
            Title is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="input-container">
        <label>
          Company Name
          <button
            mat-icon-button
            class="btn-hint"
            matTooltip="Company registering for account"
          >
            <mat-icon>help</mat-icon>
          </button></label
        >
        <mat-form-field appearance="outline">
          <input matInput formControlName="companyName" />
          <mat-error *ngIf="errorHandling('companyName', 'required')">
            Company Name is <strong>Required</strong>
          </mat-error>
          <mat-error
            *ngIf="form.controls.companyName.hasError('specialCharacters')"
          >
            No special characters allowed in company name
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-container">
        <label> Work Phone Number </label>
        <mat-form-field appearance="outline" floatLabel="always">
          <input
            formControlName="phoneNumber"
            digitalPlatformPhoneFormat
            matInput
            placeholder="_ _ _ - _ _ _ - _ _ _ _"
          />
          <mat-error *ngIf="errorHandling('phoneNumber', 'required')">
            Phone Number is <strong>required</strong>
          </mat-error>
          <mat-error *ngIf="errorHandling('phoneNumber', 'pattern')">
            Phone Number Format Must be a ___-___-____
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col">
      <div class="input-container">
        <label>
          Invite Code
          <button
            mat-icon-button
            class="btn-hint"
            matTooltip="Invite Code (if applicable)"
          >
            <mat-icon>help</mat-icon>
          </button></label
        >
        <mat-form-field appearance="outline">
          <input
            matInput
            formControlName="inviteCode"
            digitalPlatformInviteCodeFormat
          />
        </mat-form-field>
      </div>
      <div class="input-container">
        <label>
          Email
          <button
            mat-icon-button
            class="btn-hint"
            matTooltip="Company email (if applicable)"
          >
            <mat-icon>help</mat-icon>
          </button></label
        >
        <mat-form-field appearance="outline">
          <input matInput formControlName="email" />
          <mat-error *ngIf="errorHandling('email', 'required')">
            Email is <strong>Required</strong>
          </mat-error>
          <mat-error *ngIf="errorHandling('email', 'email')">
            Please enter a valid email address
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-container">
        <label> Password </label>
        <mat-form-field appearance="outline">
          <input
            matInput
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
            (focus)="showFeedback = true"
          />
          <button
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Toggle Password Visibility"
            color="primary"
            class="toggle-password-button"
            [class.password-visible]="showPassword"
            (click)="showPassword = !showPassword"
          >
            <mat-icon>{{
              showPassword ? 'visibility_off' : 'visibility'
            }}</mat-icon>
          </button>
          <mat-error *ngIf="errorHandling('password', 'required')">
            Password is <strong>Required</strong>
          </mat-error>
          <mat-error *ngIf="errorHandling('password', 'passwordRequirements')">
            Password does not meet requirements
          </mat-error>
        </mat-form-field>
        <digital-platform-password-feedback
          *ngIf="showFeedback"
          [password]="form.get('password').value$ | async"
        ></digital-platform-password-feedback>
      </div>
      <div class="content-align-left input-container">
        <mat-checkbox formControlName="agreeTermsOfService" class="text-wrap">
          By clicking Sign Up I agree to the
          <a
            target="_blank"
            rel="noopener"
            href="https://www.republicservices.com/terms-of-use"
            ><strong>Terms of Service</strong></a
          >
          and
          <a
            target="_blank"
            rel="noopener"
            href="https://www.republicservices.com/privacy-policy"
            ><strong>Privacy Policy</strong></a
          >
        </mat-checkbox>
        <mat-error
          class="error subscript"
          *ngIf="errorHandling('agreeTermsOfService', 'required')"
        >
          You must agree to the Terms of Service and Privacy Policy
        </mat-error>
      </div>
    </div>
  </div>
</form>
